export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14582.f697691e.jpg";